import { render } from "./registerCorporateclient.vue?vue&type=template&id=4640cb6f&scoped=true"
import script from "./registerCorporateclient.vue?vue&type=script&lang=js"
export * from "./registerCorporateclient.vue?vue&type=script&lang=js"

import "./registerCorporateclient.vue?vue&type=style&index=0&id=4640cb6f&scoped=true&lang=css"

import exportComponent from "/var/www/html/garbage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4640cb6f"]])

export default __exports__